import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from 'flow/components/ui-components/BaseModal';

const MessageAttachmentTooLargeDialog = () => {
    const { i18next } = useAppContext();

    return (
        <BaseModal open={true} header={i18next.t('chat.attachment.too_large')}>
            <p className="ps-3 text-sm">
                {i18next.t('chat.attachment.size_exceeded')}
            </p>
        </BaseModal>
    );
};

export default MessageAttachmentTooLargeDialog;
